import 'floating-vue/dist/style.css'

import { createApp } from 'vue'

import { VueQueryPlugin } from '@tanstack/vue-query'

import App from './App.vue'
import { queryClient } from './queryClient'
import router from './router'

import './style.css'

import {
  breakpoints,
  scaleLayout,
  trackNetworkStatus,
} from '@collector/shared-ui'

import { appRootElementSelector } from './consts'
import { initDatabase } from './utils/database'
import { getHandleError } from './utils/errorHandler'
import { initSentry } from './utils/sentry/init'

if (!import.meta.env.DEV) {
  // eslint-disable-next-line
  console.log(import.meta.env.VITE_RELEASE_NAME)
  trackNetworkStatus()
}

const app = createApp(App)

const handleError = getHandleError()

// handle sync errors
app.config.errorHandler = handleError

// async errors (rejected promise) not handled by Vue app
window.addEventListener('unhandledrejection', (event) => {
  // prevent default to skip logging "Uncaught (in promise)" in console
  event.preventDefault()

  handleError(event.reason)
})

initSentry(app, router)

app.use(router)
app.use(VueQueryPlugin, { queryClient })

if (screen.availWidth > breakpoints['2xl']) {
  /**
   * `scaleLayout` must be run before app is mounted
   *
   * otherwise, it could cause glitches:
   * `@container` breakpoints might not work properly when <html> font-size is not yet set
   * - glitch would render wrong layout at `@container` breakpoint after refreshing app
   */
  scaleLayout(import.meta.env.VITE_APP_MODE, 960)
}
app.mount(appRootElementSelector)

initDatabase()
